import '../routes';
import _RouteInitMiddleware from '../routes/middleware/_RouteInitMiddleware';
import _AfterEachMiddleware from '../routes/middleware/_AfterEachMiddleware';

import RouterBuilder from '../core/router-builder';

RouterBuilder.addInitialMiddleware(_RouteInitMiddleware);
RouterBuilder.addAfterEachClosure(_AfterEachMiddleware);

export default RouterBuilder.getRouter();